import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import BooleanIcon from 'Components/Core/BooleanIcon';
import './PollAdmin.css';

// Nur anlegen/schliessen/loeschen - keine nachtraegliche Bearbeitung von
// Frage/Optionen, daher kein onEditRow (Umfragen sind nach dem Anlegen fix).
export default function PollAdmin(props) {

	const x = props.x;
	const wafId = props.id;
	const dialogFormId = "form-" + props.id;
	const [reloadKey, setReloadKey] = React.useState(0);
	let currentPollId = 0;

	function closePoll(e, pollId) {
		e.stopPropagation();
		x.was.axPost('Backend/webapp.php?module=Poll&task=ClosePoll', { pollId: pollId }, () => {
			setReloadKey(k => k + 1);
		});
	}

	const formFields =
		<React.Fragment>
			<FormElement type="text" x={x} wafId={wafId} id="question" mandatory={true} title="Frage" fieldValue="" maxLength="500" />
			<FormElement type="text" x={x} wafId={wafId} id="option1" mandatory={true} title="Option 1" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option2" mandatory={true} title="Option 2" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option3" mandatory={false} title="Option 3" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option4" mandatory={false} title="Option 4" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option5" mandatory={false} title="Option 5" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option6" mandatory={false} title="Option 6" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option7" mandatory={false} title="Option 7" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option8" mandatory={false} title="Option 8" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option9" mandatory={false} title="Option 9" fieldValue="" maxLength="255" />
			<FormElement type="text" x={x} wafId={wafId} id="option10" mandatory={false} title="Option 10" fieldValue="" maxLength="255" />
			<FormElement type="checkbox" x={x} wafId={wafId} id="ismultiplechoice" title="Mehrfachauswahl erlauben" />
			<FormElement type="checkbox" x={x} wafId={wafId} id="showresultsafterclose" title="Ergebnis erst nach Schließung sichtbar" />
		</React.Fragment>

	return (
		<ModuleTable
			id={props.id}
			tableId="pollid"
			dialogFormId={dialogFormId}
			x={x}
			classes="module-poll-admin"
			tableClasses="poll-admin-table"
			title={props.title}
			addDeleteRow={true}
			addTitle="Neue Umfrage anlegen"
			reloadKey={reloadKey}
			filterableColumns={['question']}
			onAfterSend={() => {
				// Eigener Hint-Check laeuft sonst nur einmal pro Seitenaufbau
				// (siehe Content.js) - ohne diesen Aufruf saehe der anlegende
				// Moderator/root selbst den Hint fuer die gerade erstellte
				// Umfrage erst nach einem Reload.
				if (typeof x.was.loadPendingPolls === 'function') x.was.loadPendingPolls();
			}}
			module="Poll"
			listTask="PollList"
			deleteTask="DeletePoll"
			onAddHeader={(addHeader) => {
				// Reihenfolge muss der Spalten-Reihenfolge aus PollList.inc
				// entsprechen (pollid/createdat werden per onAddColumn
				// ausgeblendet und verbrauchen daher keinen Header-Slot).
				// Kurze Ein-Wort-Header fuer die Icon-Spalten (wie "Versteckt"/
				// "Inaktiv"/"Icon" im Page-Store-Vorbild) - Table.js hat keine
				// feste Spaltenbreite, Header- und Datenzeile werden unabhaengig
				// per Flex-Content-Breite positioniert. Ein deutlich breiterer
				// Header als der eigentliche (Icon-)Zelleninhalt verschiebt
				// sichtbar alle nachfolgenden Spalten.
				addHeader('Frage');
				addHeader('Mehrfach');
				addHeader(<span title="Geschlossen (Icon anklicken zum Schließen)">Status</span>);
				addHeader(<span title="Ergebnis erst nach Schließung sichtbar">Ergebnis</span>);
				addHeader('Stimmen');
			}}
			onAddColumn={(key, value) => {
				switch (key) {
					// 'pollid' wird als erste Spalte je Zeile durchgereicht (siehe
					// listTask-Reihenfolge in PollList.inc) - hier zwischenspeichern,
					// da onAddColumn nur (key, value) ohne die ganze Zeile erhaelt.
					case 'pollid':
						currentPollId = value;
						return false;
					case 'question':
						return value;
					case 'ismultiplechoice':
					case 'showresultsafterclose':
						return <BooleanIcon value={value} />;
					case 'votecount':
						return value;
					case 'isclosed':
						return (parseInt(value, 10) === 1)
							? <i className="bi bi-lock-fill poll-status-icon poll-status-closed" title="Geschlossen" />
							: <i className="bi bi-unlock poll-status-icon poll-status-open" title="Offen - klicken zum Schließen" onClick={(e) => closePoll(e, currentPollId)} />;
					case 'createdat':
						return false;
					default:
						return false;
				}
			}}
			formFields={formFields}
			formSendTask="CreatePoll"
		/>
	)

};
